// extracted by mini-css-extract-plugin
export default {"btnReset":"ButtonLogin_btnReset__k+Yt1","btnLogin":"ButtonLogin_btnLogin__S2UlD","btnRegistration":"ButtonLogin_btnRegistration__GpQsI","btnLogout":"ButtonLogin_btnLogout__8NNKs"};